import React, { useState } from 'react'
import { useParams, useLocation, withRouter } from 'react-router-dom'
import { Box, CircularProgress } from '@material-ui/core'
import { styled } from '@material-ui/styles'
import { AdNetworkTabLayout } from './ad-network-tab-layout'

const IFrameWrapper = styled(Box)(() => ({
  height: '100%',
  position: 'relative' as const,
}))

const AdNetworkTermsPageRaw = () => {
  const { workspaceId } = useParams<{ workspaceId: string }>()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const action = searchParams.get('action')
  const [iframeLoaded, setIframeLoaded] = useState(false)
  return (
    <AdNetworkTabLayout>
      <IFrameWrapper>
        {!iframeLoaded && (
          <Box style={{
            position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
            display: 'flex', justifyContent: 'center', alignItems: 'center',
          }}>
            <CircularProgress />
          </Box>
        )}
        <iframe
          src={`${process.env.REACT_APP_SCREENHUB_CONTROL_URL}/ad-network/terms?workspaceId=${workspaceId}${action ? `&action=${action}` : ''}`}
          title="ad-network-terms"
          onLoad={() => setIframeLoaded(true)}
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
          }}
        />
      </IFrameWrapper>
    </AdNetworkTabLayout>
  )
}

export const AdNetworkTermsPage = withRouter(AdNetworkTermsPageRaw)
